// extracted by mini-css-extract-plugin
module.exports = {"main":"ZoneRawData-module--main--3vk9u","compare":"ZoneRawData-module--compare--1OxlM"};